import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import { IconTypeNames } from "Components/Icon";
import LoadingButton from 'Components/LoadingButton';
import TermsAndConditions from "Components/TermsAndConditions";
import { Routes, PRODUCTTYPES, FUND_SOURCE_TYPE } from "Utils/Constants";
import { useMediaQuery } from 'react-responsive';
import "./TransferFunds.scss";
import useSession from "Utils/Hooks/useSession";
import useTransactionInitiated from "Utils/Hooks/useTransactionInitiated";
import AvailableFundsBase from "Components/AvailableFunds/AvailableFundsBase";
import useFundType from "Utils/Hooks/useFundType";
import CancelButton from "Components/CancelButton";
import useSessionStorage from "Utils/Hooks/useSessionStorage";
import add from 'Assets/Icons/add.svg';
import bank from 'Assets/Icons/menu-bank.svg';
import FormField from "Components/Fields/FormField";
import { AddTrailingZeros } from "Utils/Utils";
import VIPPreferredLogo from "Assets/Img/vipp-logo.png";
import VIPOnlineLogo from "Assets/Img/vipo-logo.png";
import useView, { VIEW } from "Utils/Hooks/useView";
import errorIcon from "Assets/Icons/error.svg";
import { faro } from "@grafana/faro-react";

const TransferFunds = ({ withdraw, vipApi, limitAmount, minAmount, messages, fundingSources, defaultFund, fundTypeName, isPlaid, operatorDailyLimit, fundingSourceList, preferredCurrentLimit, preferredPreviousLimit, noWarranty, unVerifiedBank }) => {
  const { session, fetchSession } = useSession();
  const view = useView();
  const productType = session?.patronProductType === PRODUCTTYPES.PREFERRED ? 'VIP Preferred' : 'VIP Online';
  const isVIPPreferred = session?.patronProductType === PRODUCTTYPES.PREFERRED;
  const logoSrc = isVIPPreferred ? VIPPreferredLogo : VIPOnlineLogo;
  const pageTitle = (isVIPPreferred ? "VIPP" : "VIPO") + " - " + (withdraw ? "Withdraw" : "Deposit");
  document.title = pageTitle;
  const [showTerms, setShowTerms] = useSessionStorage('vip-showTerms');
  //const [view, setView] = useSessionStorage('vip-view');
  const [sessionStorageTransAmount, setSessionStorageTransAmount] = useSessionStorage('vip-transaction-amount');
  const [isRepeat, setIsRepeat] = useSessionStorage("isRepeat", false);
  const { setTransactionInitiated } = useTransactionInitiated();
  const history = useHistory();
  const title = (defaultFund && defaultFund?.bankName.toUpperCase().substring(0, 24) + " x" + defaultFund?.accountNumberDisplay) || `Select ${fundTypeName}`;
  const [dropdownTitle, setDropdownTitle] = useState(title);
  const [selectedFund, setSelectedFund] = useState(defaultFund);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const modalUp = useRef(null);
  const handleClose = () => {
    setShowConfirmation(false);
    modalUp.current = false;
  }
  const fundType = useFundType();
  const refs = useRef([]);
  refs.current = [];
  const [isLimitLoading, setIsLimitLoading] = useState(false);
  const [limitAmountState, setLimitAmountState] = useState(limitAmount); // Because for Hybrid work, the limitAmount is getting 1, the transaction is not <= than $1 (Lower of wallet balance or Oper Max withdraw)
  const bankAccountLimitMet = fundingSourceList.current.length === 4; //fundType === 'netspend' ? fundingSources?.length === 3 : fundingSources?.length === 4;
  const [transactionAmount, setTransactionAmount] = useState(session.transactionAmount);
  const [transactionAmt, setTransactionAmt] = useState(session.transactionAmount);
  const isMobile = useMediaQuery({
    query: '(max-width: 767.98px)'
  });

  // New Code for Edit Amount
  const amountFieldRef = useRef(session.sessionStorageTransAmount);
  const domElements = [];
  const [selectedAmount, setSelectedAmount] = useState();
  const [btnEnabled, setBtnEnabled] = useState(false);
  const submitButtonText = withdraw ? "withdraw" : "deposit";
  const [displayLabel, setDisplayLabel] = useState(false);
  const [isBankSelected, setIsBankSelected] = useState(false);

  const isCashier = view === VIEW.cashier;
  var cashierCss = '';
  Object.values(session.uiStyleFields).forEach((style) => { cashierCss += style });

  useEffect(() => {
    if (!isBankSelected) {
      setSelectedFund(defaultFund);
      setDropdownTitle((defaultFund && defaultFund?.bankName.toUpperCase().substring(0, 24) + " x" + defaultFund?.accountNumberDisplay) || `Select ${fundTypeName}`);
    }
    if (!withdraw && isPlaid) {
      if (selectedFund) {
        let dailyLimit = Math.min(operatorDailyLimit, selectedFund.availableLimit);
        setLimitAmountState(dailyLimit);
        window.sessionStorage.setItem("selectedFundDetails", JSON.stringify(selectedFund));
        if (session.toggles.isAmountEditable) {
          setTransactionAmount(transactionAmt);
          if (amountFieldRef.current) {
            amountFieldRef.current.setFieldValue(sessionStorageTransAmount);
          }
        }
        setDisplayLabel(selectedFund.totalLimit > selectedFund?.vipoPreviousLimit);
      }
      else {
        setLimitAmountState(operatorDailyLimit);
        setDisplayLabel(operatorDailyLimit > defaultFund?.vipoPreviousLimit);
      }
    }
    else {
      setLimitAmountState(limitAmount);
      setDisplayLabel(preferredCurrentLimit > preferredPreviousLimit);
    }
    setIsLimitLoading(false);
    setIsRepeat(true);
  }, [selectedFund, limitAmount, vipApi, withdraw]);

  function onBankSelected(bankAccount) {
    faro.api.pushEvent(`User selected account ${bankAccount.accountNumberDisplay} from dropdown list for transaction`);
    setDropdownTitle(bankAccount.bankName?.toUpperCase().substring(0, 24) + " x" + bankAccount.accountNumberDisplay);
    setIsBankSelected(true);
    setSelectedFund(bankAccount);
    if (!withdraw && isPlaid) {
      let dailyLimit = Math.min(operatorDailyLimit, selectedFund.availableLimit);
      setLimitAmountState(dailyLimit);
      window.sessionStorage.setItem("selectedFundDetails", JSON.stringify(bankAccount));
      if (session.toggles.isAmountEditable) {
        setTransactionAmount(undefined);
        if (amountFieldRef.current) {
          amountFieldRef.current.setFieldValue(undefined);
        }
        setBtnEnabled(true);
      }
      setDisplayLabel(bankAccount.totalLimit > selectedFund.vipoPreviousLimit);
    }
  }

  function onLinkSelected(destination) {
    faro.api.pushEvent(
      `User clicked ${
        destination === "addAccount" ? "Add New" : "Manage"
      } Funding Source from dropdown list for transaction`
    );
    if (isCashier) {
      vipApi.fetch("/api/patronsession/updateuiparams", "POST",
        {
          uiStartingPath: '/' + destination,
          uiStartingAction: FUND_SOURCE_TYPE.PLAID
        })
        .then(response => {
          setShowTerms(false);
          if (response.ok) {
            const platform = navigator.userAgent.toLowerCase();
            if (platform.includes('iphone') || platform.includes('ipad') || platform.includes('ipod')) {
              window?.webkit?.messageHandlers?.NativeBridge?.postMessage("opensdk");
            } else if (platform.includes('android')) {
              window.postMessage("opensdk", "*");
            } else {
              window.postMessage("opensdk", "*");
            }
          }
          else {
            faro.api.pushError(new Error("Cashier Transfer Funds Update Error"), { context: response });
            history.push({
              pathname: '/error',
              state: {
                isError: true,
                message: "Unable to process your request at this time. For further assistance, please contact Pavilion Gaming Services customer support at 1-800-500-1973 with reference code E-99.",
                showButton: true,
                allowRetry: false
              }
            });
          }
        })
        .catch((error) => {
          faro.api.pushError(new Error("Cashier Transfer Funds Network Error"), { context: error });
          console.error(error);
          history.push({
            pathname: '/error'
          });
        });

    }
    else {
      if (destination === "addAccount") {
        history.push({
          pathname: "/addAccount",
          state: { notRedirect: true },
        });
      } else {
        history.push(destination);
      }
    }
  }

  function onFieldChange(fieldName, fieldValue, isValid) {
    if (session.toggles.isAmountEditable) {
      setTransactionAmt(fieldValue);
      setSessionStorageTransAmount(fieldValue);
    }
    setTransactionAmount(fieldValue);
    if (isValid) {
      setBtnEnabled(true);
    }
    else {
      setBtnEnabled(false);
    }
  }

  function formatTransferAmount(transferAmount) {
    if(!transferAmount) return transferAmount;
    if(transferAmount.toString().indexOf('.') < 0) return transferAmount;
    let parts = transferAmount.toString().split('.');
    switch(parts[1].length) {
      case 0:
        return transferAmount + "00";
      case 1:
        return transferAmount + "0"
      default:
        return transferAmount;
    }
  }

  async function onSuccess() {
    await fetchSession(true);
    window.sessionStorage.setItem("IsRedirectOrCancel", true);
    window.sessionStorage.setItem("plaidlaunch", false);
    const amount = formatTransferAmount(transactionAmount);
    const bankName = selectedFund.bankName;
    const oprName = session.operatorName;

    let customButtons = [];
    var redirectUrl = null;

    if (!session.toggles.showDashboardButtonAfterSuccess) {
      redirectUrl = {
        transactionSucceeded: true,
        returnUrl: session.returnUrl,
        transactionId: session.transactionId,
        transactionType: withdraw ? "withdraw" : "deposit",
      };
      customButtons.push({
        label:
          redirectUrl && !session.showTransactionConfirmation
            ? `You are being redirected to `
            : `CONTINUE TO ${oprName.toUpperCase()}`,
        returnToOperator: true,
        returnUrl: session.returnUrl,
        transactionSucceeded: true,
        transactionId: session.transactionId,
        transactionType: withdraw ? "withdraw" : "deposit",
      });
    } else {
      customButtons.push({
        label: `CONTINUE TO ${oprName.toUpperCase()}`,
        returnToOperator: true,
        returnUrl: session.returnUrl,
        transactionSucceeded: true,
        transactionId: session.transactionId,
        transactionType: withdraw ? "withdraw" : "deposit",
      });

      customButtons.push({
        label: `MANAGE ${productType.toUpperCase()}`,
        route: Routes.DASHBOARD,
        returnUrl: session.returnUrl,
        transactionSucceeded: true,
        transactionId: session.transactionId,
        transactionType: withdraw ? "withdraw" : "deposit",
      });
    }

    let location = {
      pathname: '/success',
      state: {
        isError: false,
        iconProps: { height: 200, width: 200 },
        title: session.toggles.depositApproval ? "Deposit In Progress" : "Deposit Successful",
        message: session.toggles.depositApproval ? `Your $${amount} deposit from your ${bankName} account to your ${oprName} account is currently in progress. The funds will be available in your ${oprName} account ${session?.uiDisplayFields?.transactionTimeframe}` : `Your $${amount} deposit was successful and your funds are now available in your ${oprName} account.`,
        customButtons,
        redirectUrl
      }
    };

    if (withdraw) {
      location.state.title = (session.toggles.isInstantWithdrawals) ? "Withdrawal Successful" : "Withdrawal In Progress";
      location.state.message = (session.toggles.isInstantWithdrawals) ? `You successfully transferred $${transactionAmount} ` +
        `from ${oprName} to your ${bankName} account.` : `Your $${amount} withdrawal from your ${oprName} account to your ${bankName} account is currently in progress. The funds will be available in your ${bankName} account ${session?.uiDisplayFields?.transactionTimeframe}`;
      location.state.iconProps = (session.toggles.isInstantWithdrawals) ? { height: 200, width: 200 } : { typeName: IconTypeNames.withdraw };
    }

    history.push(location);
  }

  function onError(response) {
    history.push({
      pathname: '/error',
      state: {
        isError: true,
        mitekRedirect : true,
        showButton: true,
        title: "Transaction Incomplete",
        message: response.patronErrorMessage ?? "Transaction Incomplete",
        allowRetry: false
      }
    });
  }

  // Submit clicked
  async function onSubmit(event) {
    event.preventDefault();
    setSubmitted(true);
    faro.api.pushEvent(`User submitted a ${withdraw ? "withdraw" : "deposit"}`);
    const url = withdraw ? "/api/funds/withdraw" : "/api/funds/deposit";
    vipApi
      .fetch(url, "POST", {
        bankName: selectedFund.bankName,
        bankRoutingNumber: selectedFund.routingNumber,
        maskedBankAccountNumber: selectedFund.maskedAccountNumber,
        achOpenType: selectedFund.achOpenType,
        checkAmount: transactionAmount,
        ipAddress: window.sessionStorage.getItem("clientIpAddress"),
      })
      .then((response) => {
        setShowTerms(false);
        setTransactionInitiated(true);
        if (response.ok) {
          faro.api.pushEvent(`Successful ${withdraw ? "withdraw" : "deposit"} transaction`);
          onSuccess();
        } else {
          faro.api.pushError(new Error("Transaction Incomplete Error"), { context: response });
          if (response.status === 500 || response.status === 504) {
            console.error(response.statusText);
            history.push({
              pathname: "/error",
            });
          } else if (response.status === 401) {
            console.error(response.statusText);
            history.push({
              pathname: "/expired",
            });
          } else if (response.status === 400) {
            response.json().then((data) => {
              history.push({
                pathname: "/error",
                state: {
                  isError: true,
                  title: "Transaction Incomplete",
                  message:
                    data.patronErrorMessage ??
                    "Unable to process your request at this time. For further assistance, please contact Pavilion Gaming Services customer support at 1-800-500-1973 with reference code E-99.",
                  showButton: true,
                  allowRetry: false,
                },
              });
            });
          } else {
            response.json().then((data) => {
              console.error(data);
              faro.api.pushError(new Error("Transaction Error"), { context: data });
              onError(data);
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
        faro.api.pushError(new Error("Transaction Incomplete Network Error"), { context: error });
        history.push({
          pathname: "/error",
        });
      });
  };

  // JSX Fragments

  const selectAmount = (amount) => {
    if (amount !== selectedAmount) {
      if(session.toggles.isAmountEditable) {
        setTransactionAmt(amount);
        setSessionStorageTransAmount(amount);
      }
      setTransactionAmount(amount)
      setSelectedAmount(amount);
      if (amountFieldRef.current) {
        amountFieldRef.current.setFieldValue(amount);
      }
      setBtnEnabled(true);
    } else {
      if(session.toggles.isAmountEditable) {
        setTransactionAmt(undefined);
        setSessionStorageTransAmount(amount);
      }
      setTransactionAmount(undefined);
      setSelectedAmount(undefined);
      if (amountFieldRef.current) {
        amountFieldRef.current.setFieldValue(undefined);
      }
      setBtnEnabled(true);
    }
  }

  const denominations = [25, 50, 100, 200, 500];
  let count = 0;
  const amounts = denominations.map((amount, index) => {
    const disabled = amount > limitAmountState;
    if (amount <= limitAmountState) count++;
    const selected = amount == transactionAmount;
    const amountClass = isCashier ? "cashier-amount" : "amount";
    const className = disabled ? amountClass + " disabled" : (selected) ? amountClass + " selected-amount" : amountClass;
    const colClassName = disabled ? "hide" : "";
    return <Col className={colClassName} key={amount}>
      <button ref={(node) => domElements.push(node)} disabled={disabled} className={className} onClick={() => { selectAmount(amount); }}><span className="super">$</span>{amount}</button>
    </Col>
  });
  const width = count * 109;
  const amountButtonClass = isCashier ? "text-center cashier-amount" : "text-center amount";
  const amountButtons = (isMobile) ? <center><Row className={amountButtonClass}> {amounts} </Row></center> : <center><Row style={{ width: width }} className={amountButtonClass}> {amounts} </Row></center>;

  const proceed = transactionAmount && transactionAmount >= minAmount && transactionAmount <= limitAmountState && selectedFund;
  const showAmountExceeded = !session.toggles.isAmountEditable && !(transactionAmount && transactionAmount >= minAmount && transactionAmount <= limitAmountState && selectedFund);
  const confirmationTitle = (withdraw) ? 'Withdraw Confirmation' : 'Deposit Confirmation';
  const isNetSpend = fundType === 'netspend';
  const bankAaccount = selectedFund?.bankName + ' ' + fundTypeName;

  const gaClass = "click-" + ((withdraw) ? "withdraw" : "deposit");
  const submitButtonClass = (isCashier ? "cashier-submit-button " : "submit-button ") + gaClass;

  // DEPOSIT BUTTON 
  const submitButton = (submitted) ?
    <LoadingButton /> :
    <>
      <button
        onClick={/*session.toggles.showTransactionConfirmation === true ? handleShow : */onSubmit}
        disabled={session.toggles.isAmountEditable ? !(proceed && btnEnabled) : !proceed}
        className={(session.toggles.isAmountEditable ? (proceed && btnEnabled) : proceed) ? submitButtonClass : submitButtonClass + " disabled"}>
        {(withdraw) ? "WITHDRAW" : "DEPOSIT"}
      </button>
      <Modal
        show={showConfirmation}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="transaction-confirmation"
        animation={false}
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Container>
              <Row>
                <Col className="modal-title">
                  {confirmationTitle}
                </Col>
              </Row>
              <Row>
                <Col className="text-center bank-text">
                  Are you sure you want to {(withdraw) ? 'withdraw' : 'deposit'} ${formatTransferAmount(transactionAmount)} {(withdraw) ? 'into' : 'from'} your {(isNetSpend) ? fundTypeName : bankAaccount}?
                </Col>
              </Row>
              <Row>
                <Col>
                  <button className="submit-button click-cancel-yes" onClick={onSubmit}>
                    YES
                  </button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <button className="submit-button click-cancel-cancel" onClick={handleClose}>
                    CANCEL
                  </button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>
    </>;

  let limitSection;

  if (isLimitLoading) {
    limitSection = <div className="limit text-center">CHECKING CARD BALANCE...</div>
  } else {
    if (withdraw) {
      limitSection = <AvailableFundsBase availableFunds={transactionAmount} headerText={`AMOUNT SELECTED ON ${session.operatorName.toUpperCase()}`} />;
    } else if (fundType === 'netspend') {
      // netspend deposit
      limitSection = <div className="limit text-center">${limitAmountState?.toLocaleString()} CARD BALANCE</div>;
    } else {
      // ach deposit
      limitSection = <AvailableFundsBase availableFunds={transactionAmount} headerText={`AMOUNT SELECTED ON ${session.operatorName.toUpperCase()}`} />;
      if (isMobile) {
        limitSection = <AvailableFundsBase availableFunds={transactionAmount} headerText={`AMOUNT SELECTED ON ${session.operatorName.toUpperCase()}`} />;
      }
    }
  }

  const bankOption = bankAccountLimitMet ? (
    <Dropdown.Item
      className="dropdown-link click-ddl-bank-account-add"
      onClick={() => {
        onLinkSelected("myAccounts");
      }}
    >
      <img src={bank} alt="Manage Bank" className="menu-icon" /> Manage Funding
      Sources
    </Dropdown.Item>
  ) : (
    <Dropdown.Item
      className="dropdown-link click-ddl-bank-account-add"
      onClick={() => {
        onLinkSelected("addAccount");
      }}
    >
      <img
        src={add}
        alt="Add Bank"
        className="menu-icon click-ddl-bank-account-add"
      />{" "}
      Add New Funding Source
    </Dropdown.Item>
  );
  const manageFundingOption = !bankAccountLimitMet && <Dropdown.Item className="dropdown-link click-ddl-bank-account-manage" onClick={() => { onLinkSelected("myAccounts") }}><img src={bank} alt="Manage Bank" className="menu-icon click-ddl-bank-account-manage" />  Manage Funding Sources</Dropdown.Item>;
  const formattedTitle = (dropdownTitle.indexOf(' *') > 0) ? <><span>{dropdownTitle.slice(0, dropdownTitle.indexOf(' *'))}</span>{dropdownTitle.slice(dropdownTitle.indexOf(' *'))}</> : dropdownTitle;

  const MINIMUM_AMOUNT = {
    errorMessage: (limitAmountState < minAmount) ? `Your deposit limit is less than the minimum ${session.operatorName.toUpperCase()} deposit amount of $${minAmount}.` : `Amount must be equal to or greater than $${minAmount}.`,
    action: (amount) => amount >= minAmount
  };

  const MAXIMUM_AMOUNT = {
    errorMessage: (limitAmountState < minAmount) ? `Your deposit limit is less than the minimum ${session.operatorName.toUpperCase()} deposit amount of $${minAmount}.` : `Amount must be equal to or less than $${limitAmountState}.`,
    action: (amount) => amount <= limitAmountState
  };

  const DOLLAR_CENTS = {
    errorMessage: 'Must be a valid amount.',
    regex: /^[0-9]+(\.[0-9]?[0-9]?)?$/
  }
  const unavailableIcon = (<img height="20" alt="Insufficient Funds in Account" className="menu-icon" src={errorIcon} />);

  return (
    <>
      { isCashier ?
        <div className="transfer-funds">
          <style>{cashierCss}</style>
          <div className="cashier-background">
          <div className="title text-center"><img className="cashier-logo" src={logoSrc} alt={productType} /></div>
          {!withdraw && <div className="cashier-limit">Your available deposit limit is ${AddTrailingZeros(limitAmountState?.toLocaleString())}</div>}
          
          <Container>
            {session.toggles.isAmountEditable && !withdraw && amountButtons}
            <Row>
              {session.toggles.isAmountEditable && <Col md={5}>
                <FormField
                  prepend="$"
                  fieldName="amount"
                  label="AMOUNT"
                  maxLength="20"
                  startValue={!isNaN(sessionStorageTransAmount) ? formatTransferAmount(sessionStorageTransAmount) : undefined}
                  required={true}
                  validators={[DOLLAR_CENTS, MINIMUM_AMOUNT, MAXIMUM_AMOUNT]}
                  onValueChanged={onFieldChange}
                  autocomplete="off"
                  ref={amountFieldRef}
                  append={`min $${limitAmountState > 0 ? minAmount : 0}<br />max $${limitAmountState}`}
                />
              </Col>}
              <Col md={session.toggles.isAmountEditable ? 7 : { span: 7, offset: 3 }}>
                <Form.Group className="mb-3" controlId="bankAccount">
                  <Form.Label>SELECT {fundTypeName.toUpperCase()}</Form.Label>
                  <Dropdown>
                    <Dropdown.Toggle variant="white" id="dropdown-basic">
                      {formattedTitle}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {fundingSources.current?.map((bankAccount, index) => {
                        const accountAvailable = ((!isVIPPreferred && !withdraw && transactionAmt < bankAccount.availableLimit) || (isVIPPreferred) || withdraw);
                        return <Dropdown.Item bsPrefix="dropdown-item click-ddl-bank-account" disabled={!accountAvailable} key={index} onClick={() => { onBankSelected(bankAccount) }}>{!accountAvailable && unavailableIcon}{bankAccount.bankName?.toUpperCase().substring(0, 24) + " x" + bankAccount.accountNumberDisplay}</Dropdown.Item>
                      })}
                      {session.toggles.manageFundingSourcesInDropdown === true && bankOption}
                      {session.toggles.manageFundingSourcesInDropdown === true && manageFundingOption}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 4, offset: 4 }}>
                {submitButton}
              </Col>
            </Row>
            <Row className="terms center-block">
              <TermsAndConditions buttonText={submitButtonText} isCashier={true} />
            </Row>
          </Container>
          <div className="cashier-limit-error">
               {showAmountExceeded && <span>Transaction Amount entered exceeded Available limit.</span>}
          </div>
          <div className="cashier-pavilionlabel">
           <span>Secure deposit powered by PavilionPayments</span>
          </div>
        </div>
        </div>
        
        :
      
        <div className="transfer-funds">
          <div className="title text-center">Complete {withdraw ? "Withdrawal" : "Deposit"}</div>
          {(noWarranty && unVerifiedBank && isVIPPreferred)&& <div className="text-center switch-message mt-3">Bank Verification was unsuccessful. We will continue using your existing manually entered bank account.</div>}
          {!session.toggles.isAmountEditable && selectedFund && limitSection}
          {!withdraw && <div className="limit text-center">${AddTrailingZeros(limitAmountState?.toLocaleString())} DEPOSIT LIMIT{displayLabel && <div><label className="limit-increase-label">&#9432; Your deposit limit has increased!</label></div>}</div>}
          <Container>
            {session.toggles.isAmountEditable && !withdraw && amountButtons}
            <Row>
              {session.toggles.isAmountEditable && <Col md={5}>
                <FormField
                  prepend="$"
                  fieldName="amount"
                  label="AMOUNT"
                  maxLength="20"
                  startValue={!isNaN(sessionStorageTransAmount) ? formatTransferAmount(sessionStorageTransAmount) : undefined}
                  required={true}
                  validators={[DOLLAR_CENTS, MINIMUM_AMOUNT, MAXIMUM_AMOUNT]}
                  onValueChanged={onFieldChange}
                  autocomplete="off"
                  ref={amountFieldRef}
                  append={`min $${limitAmountState > 0 ? minAmount : 0}<br />max $${limitAmountState}`}
                />
              </Col>}
              <Col md={session.toggles.isAmountEditable ? 7 : { span: 7, offset: 3 }}>
                <Form.Group className="mb-3" controlId="bankAccount">
                  <Form.Label>SELECT {fundTypeName.toUpperCase()}</Form.Label>
                  <Dropdown>
                    <Dropdown.Toggle variant="white" id="dropdown-basic">
                      {formattedTitle}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {fundingSources.current?.map((bankAccount, index) => {
                        const accountAvailable = ((!isVIPPreferred && !withdraw && transactionAmt < bankAccount.availableLimit) || (isVIPPreferred) || withdraw);
                        return <Dropdown.Item bsPrefix="dropdown-item click-ddl-bank-account" disabled={!accountAvailable} key={index} onClick={() => { onBankSelected(bankAccount) }}>{!accountAvailable && unavailableIcon}{bankAccount.bankName?.toUpperCase().substring(0, 24) + " x" + bankAccount.accountNumberDisplay}</Dropdown.Item>
                      })}
                      {session.toggles.manageFundingSourcesInDropdown === true && bankOption}
                      {session.toggles.manageFundingSourcesInDropdown === true && manageFundingOption}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 4, offset: 4 }}>
                {submitButton}
              </Col>
            </Row>
            <Row className="terms center-block">
              {/* <TermsAndConditions onAcceptChange={setTermsAccepted} forceShow={showTerms !== null ? showTerms : session.showTermsAndConditions} /> */}
              <TermsAndConditions buttonText={submitButtonText} isCashier={false} />
            </Row>
            <Row className="text-center center-block">
              {showAmountExceeded && <span className="available-limit-error">Transaction Amount entered exceeded Available limit.</span>}
            </Row>
            <Row>
              <Col md={{ span: 4, offset: 4 }}>
                <CancelButton btnText={withdraw ? "Withdrawal" : "Deposit"} stage={withdraw ? "Withdrawal" : "Deposit"}></CancelButton>
              </Col>
            </Row>
          </Container>
        </div>
      }
    </>
  );
};

export default TransferFunds;